import autoTable from "jspdf-autotable";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent";

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function drawGrandTotal(doc, totals) {
  const startY = 10

  autoTable(doc, {
    startY,
    ...PDF_TABLE_STYLE,
    theme: "grid",

    head: [[
      "Description",
      "HS Time",
      "HS Cost",
      "S Time",
      "S Cost",
      "SS Time",
      "SS Cost",
      "US Time",
      "US Cost",
      "OC Labour",
      "OC Store",
    ]],

    body: [[
      "GRAND TOTAL",
      format(totals.highlyskilledtime),
      format(totals.highlyskilledcost),
      format(totals.skilledtime),
      format(totals.skilledcost),
      format(totals.semiskilledtime),
      format(totals.semiskilledcost),
      format(totals.unskilledtime),
      format(totals.unskilledcost),
      format(totals.oncostlabour),
      format(totals.oncoststore),
    ]],

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_GRAND_TOTAL,
      cellPadding: 2,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_GRAND_TOTAL,
      textColor: PDFCOLORSHEME.FONT_COLOR_GRAND_TOTAL,
      fontStyle: "bold",
      halign: "center",
    },

    columnStyles: {
      0: {
        halign: "left",
        fontStyle: "bold",
        cellWidth: 40,
      },
    },

    // didParseCell(data) {
    //   if (data.section === "body") {
    //     data.cell.styles.fontStyle = "bold";
    //     data.cell.styles.fillColor = [230, 240, 255];
    //   }
    // },
  });
}